import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/Navbar";

const WORLDS = [
  { id: "aws", path: "/aws", num: "01", accent: "#f59c1a" },
  { id: "martech", path: "/martech", num: "02", accent: "#ca3b42" },
  { id: "people", path: "/people-hr", num: "03", accent: "#0d9488" },
];

const HomeD = () => {
  const { t, lang } = useLang();
  const [hover, setHover] = useState(null);
  const navigate = useNavigate();

  return (
    <div data-testid="home-d" className="min-h-[100svh] bg-[#FAFAFD] text-[#353535] grid lg:grid-cols-[420px_1fr]">
      <div className="flex flex-col justify-between p-6 sm:p-10 border-b lg:border-b-0 lg:border-r border-black/10">
        <div className="flex items-center justify-between">
          <Logo />
          <LangToggle />
        </div>
        <div className="py-10 lg:py-0">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-cabinet font-bold tracking-tight leading-[1.05] text-4xl sm:text-5xl"
          >
            {lang === "es" ? (
              <>Trabaja mejor <span className="text-[#4361ee]">con datos.</span></>
            ) : (
              <>Work better <span className="text-[#4361ee]">with data.</span></>
            )}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-5 text-sm sm:text-base font-jakarta text-[#999999] leading-relaxed"
          >
            {t.gateway.sub}
          </motion.p>
        </div>
        <div />
      </div>

      <div className="flex flex-col justify-center px-6 sm:px-14 py-10">
        {WORLDS.map((w, i) => {
          const c = t.gateway.worlds[w.id];
          const active = hover === w.id;
          return (
            <motion.button
              key={w.id}
              data-testid={`homed-select-${w.id}`}
              onClick={() => navigate(w.path)}
              onMouseEnter={() => setHover(w.id)}
              onMouseLeave={() => setHover(null)}
              initial={{ opacity: 0, x: 24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.55, delay: 0.2 + i * 0.12 }}
              className="group flex items-center gap-6 sm:gap-10 border-b border-black/10 last:border-b-0 py-9 sm:py-12 text-left"
            >
              <span className="font-jbmono text-sm text-[#999999] transition-colors duration-300" style={active ? { color: w.accent } : {}}>
                {w.num}
              </span>
              <div className="flex-1">
                <div className={`font-cabinet font-bold tracking-tight leading-none text-3xl sm:text-5xl lg:text-6xl transition-all duration-500 ${active ? "translate-x-3" : ""}`} style={active ? { color: w.accent } : {}}>
                  {c.name}
                </div>
                <div className={`mt-2 font-jbmono text-[10px] uppercase tracking-[0.25em] transition-colors duration-300 ${active ? "" : "text-[#999999]"}`} style={active ? { color: w.accent } : {}}>
                  {c.tag}
                </div>
              </div>
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full border transition-all duration-500 ${active ? "rotate-0 border-transparent text-white" : "rotate-45 border-black/15"}`} style={active ? { backgroundColor: w.accent } : {}}>
                <ArrowUpRight size={19} />
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default HomeD;
